<template>
    <v-card
        elevation="0"
        :rounded="$vuetify.display.lgAndUp ? 'lg' : false"
        class="mt-lg-5 mt-0 py-10"
    >
        <motonet-header>
            <div class="text-h6 ml-2 ml-md-0 text-md-h4  font-weight-black">
                {{ $t('eshop::modals.alternatives') }} "{{ product.name }}"
            </div>
        </motonet-header>
        <div class="d-flex product-swiper align-center mt-5 mt-md-10 position-relative" :class="{
            'border-t': $vuetify.display.smAndDown
        }">
            <div class="swiper-button-prev mr-4" id="swiper-prev-alternatives">
                <v-icon :icon="mdiArrowLeft" color="grey-darken-1"></v-icon>
            </div>
            <swiper
                :modules="[Navigation]"
                class="d-flex align-center align-self-stretch"
                :space-between="$vuetify.display.lgAndUp ? 10 : 0"
                :breakpoints="breakpoints"
                :touch-start-prevent-default="false"
                :navigation="{
                                nextEl: '#swiper-next-alternatives',
                                prevEl: '#swiper-prev-alternatives',
                            }"
            >
                <swiper-slide v-for="product in product.alternatives" :key="product.id">
                    <div class="pa-lg-4" :class="{
                        'border-b border-e': $vuetify.display.smAndDown
                    }">
                        <base-product :product="product" :css-class="['h-100']" />
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-next ml-4" id="swiper-next-alternatives">
                <v-icon :icon="mdiArrowRight" color="grey-darken-1"></v-icon>
            </div>
        </div>
    </v-card>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import BaseProduct from './BaseProduct.vue';
import { useDisplay } from 'vuetify';
import { markRaw, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { usePriceStore } from '../stores/price';
import pinia from '../../../../plugins/pinia';
import MotonetHeader from './MotonetHeader.vue';
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js';

const props = defineProps({
    product: Object,
});

const { thresholds } = useDisplay();

const store = usePriceStore(pinia);
watch(() => props.product.alternatives, (val => {
    if (!usePage().props.customer.id) {
        return;
    }
    if (val) {
        const ids = [];
        if (val.length) {
            props.product.alternatives.forEach((alt) => {
                if (store.prices[alt.id]) {
                    alt.price = store.prices[alt.id].nice_price.replace('CZK', 'Kč');
                    alt.price_no_vat = store.prices[alt.id].nice_price_without_vat.replace('CZK', 'Kč');
                } else {
                    ids.push(alt.id);
                }
            });
        }
        if (ids.length) {
            store.loadPricesFromApi(ids, usePage().props.customer.id).then(prices => {
                const length = ids.length;
                for (let i = 0; i < length; i++) {
                    const product = props.product.alternatives.find(p => p.id === ids[i]);
                    if (product && prices[product.id]) {
                        product.price = prices[product.id].nice_price.replace('CZK', 'Kč');
                        product.price_no_vat = prices[product.id].nice_price_without_vat.replace('CZK', 'Kč');
                    }
                }
            });
        }
    }
}), { immediate: true, deep: true });

const breakpoints = markRaw({
    [thresholds.value.lg]: {
        slidesPerView: 4,
    },
    [thresholds.value.md]: {
        slidesPerView: 3,
    },
    [thresholds.value.sm]: {
        slidesPerView: 2,
    },
    [thresholds.value.xs]: {
        slidesPerView: 2,
    },
});

</script>

<style scoped>

</style>
